<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><span class="link-effect">Inducciones por Vencer</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Inducciones por Vencer</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.idCompania" [disabled]="listaCompanias.length == 1"
              (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.sedes" name="sedes" multiple>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Trabajador:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Nombres y Apellidos </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nombreEmpleado" name="nombreEmpleado"
                maxlength="40" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Nro Documento:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nro Documento</mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nroDocumento" name="nroDocumento" maxlength="15"
                (keypress)="keyPressNumberOnly($event)" />
            </mat-form-field>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Contratista </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.nombreContratista" name="nombreContratista"
                maxlength="40" />
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Fecha de Vencimiento:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Fecha de Vencimiento</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Desde" [(ngModel)]="modelFilter.fechaInicio" />
                <input matEndDate placeholder="Hasta" [(ngModel)]="modelFilter.fechaFin" />
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>
        </div>

      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">

            <a class="btn btn-cyan" mat-raised-button
              (click)="reprogramarInduccion()"><mat-icon>calendar_today</mat-icon>
              Programar</a>
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table mat-table [dataSource]="modelListaInducciones" class="table table-striped table-vcenter">

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajador">
            <th mat-header-cell *matHeaderCellDef>Trabajador</th>
            <td mat-cell *matCellDef="let element">
              {{ element.persona.nombres }} {{ element.persona.apellidoPaterno }}
              {{ element.persona.apellidoMaterno }}
            </td>
          </ng-container>

          <ng-container matColumnDef="nroDocumentoIdentidad">
            <th mat-header-cell *matHeaderCellDef>Nro. Documento Identidad</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.persona.nroDocumentoIdentidad }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fechaAprobacion">
            <th mat-header-cell *matHeaderCellDef>Fecha Aprobación</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaAprobacion | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fechaVencimiento">
            <th mat-header-cell *matHeaderCellDef>Fecha Vencimiento</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaFin | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.sede }}</td>
          </ng-container>

          <!-- <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">{{ element.solicitante }}</td>
          </ng-container> -->

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">
              {{ element.contratista }}
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código Solicitud</th>
            <td mat-cell *matCellDef="let element">
              {{ element.codigoSolicitud }}
            </td>
          </ng-container> -->

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox [(ngModel)]="element.programarInduccion"></mat-checkbox>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>

</div>